// extracted by mini-css-extract-plugin
module.exports = {"code":"ObjectAssign_code__l0Wjn"};